export default __webpack_public_path__ + "static/media/machine-learning.32ee80fb.svg";